import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import './styles.css';
import SwiperCore, {
    Navigation
} from 'swiper/core';
import { useAppSelector } from '../../core/hooks';

SwiperCore.use([Navigation]);

const Row = ({ shows, title, index }: any) => {

    const userName = useAppSelector(state => state.user.name);

    return (
        <div className='row'>
            <div className="row__title">{index === 0 ? `For ${userName}` : title}</div>
            <Swiper slidesPerView={"auto"} freeMode={true} spaceBetween={15} navigation={true} className="mySwiper">
                {shows.map((show: any) => (
                    <SwiperSlide className="show" key={show.id}>
                        <img className="img-fluid" src={`https://image.tmdb.org/t/p/w185${show.poster_path}`} alt={show.title} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>

    );
};

export default Row;